import { useState } from 'react'
import { Modal } from './Modal'
import './AppointmentCancelModal.css'

interface AppointmentCancelModalProps {
  appointment: {
    id: string
    patientName: string
    staffName: string
    appointmentDate: string
    startTime: string
    type: string
  }
  isOpen: boolean
  onClose: () => void
  onConfirm: (reason?: string) => Promise<void>
  isLoading?: boolean
}

export function AppointmentCancelModal({
  appointment,
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: AppointmentCancelModalProps) {
  const [reason, setReason] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    await onConfirm(reason.trim() || undefined)
    setReason('') // Reset form on success
  }

  const handleClose = () => {
    if (!isLoading) {
      setReason('')
      onClose()
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Cancel Appointment">
      <form onSubmit={handleSubmit} className="appointment-cancel-form">
        <div className="appointment-cancel-info">
          <p>
            <strong>Patient:</strong> {appointment.patientName}
          </p>
          <p>
            <strong>Staff:</strong> {appointment.staffName}
          </p>
          <p>
            <strong>Date:</strong> {new Date(appointment.appointmentDate).toLocaleDateString()}
          </p>
          <p>
            <strong>Time:</strong> {appointment.startTime}
          </p>
          <p>
            <strong>Type:</strong> {appointment.type}
          </p>
        </div>

        <div className="form-group">
          <label htmlFor="cancellation-reason">
            Cancellation Reason <span className="optional">(optional)</span>
          </label>
          <textarea
            id="cancellation-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={4}
            placeholder="Enter reason for cancellation (e.g., patient request, rescheduled, etc.)"
            disabled={isLoading}
          />
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="btn-secondary"
            onClick={handleClose}
            disabled={isLoading}
          >
            Keep Appointment
          </button>
          <button
            type="submit"
            className="btn-danger"
            disabled={isLoading}
          >
            {isLoading ? 'Cancelling...' : 'Cancel Appointment'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
